/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiBroadcastBroadcastStatisticsGet } from '../fn/broadcast/api-broadcast-broadcast-statistics-get';
import { ApiBroadcastBroadcastStatisticsGet$Params } from '../fn/broadcast/api-broadcast-broadcast-statistics-get';
import { apiBroadcastCheckUtdbGet } from '../fn/broadcast/api-broadcast-check-utdb-get';
import { ApiBroadcastCheckUtdbGet$Params } from '../fn/broadcast/api-broadcast-check-utdb-get';
import { apiBroadcastDevTestGet } from '../fn/broadcast/api-broadcast-dev-test-get';
import { ApiBroadcastDevTestGet$Params } from '../fn/broadcast/api-broadcast-dev-test-get';
import { apiBroadcastEnableKiutPost } from '../fn/broadcast/api-broadcast-enable-kiut-post';
import { ApiBroadcastEnableKiutPost$Params } from '../fn/broadcast/api-broadcast-enable-kiut-post';
import { apiBroadcastFetchRedsysStartDurationPost } from '../fn/broadcast/api-broadcast-fetch-redsys-start-duration-post';
import { ApiBroadcastFetchRedsysStartDurationPost$Params } from '../fn/broadcast/api-broadcast-fetch-redsys-start-duration-post';
import { apiBroadcastFixArchiveDurationPost } from '../fn/broadcast/api-broadcast-fix-archive-duration-post';
import { ApiBroadcastFixArchiveDurationPost$Params } from '../fn/broadcast/api-broadcast-fix-archive-duration-post';
import { apiBroadcastFixArchiveStatisticsPost } from '../fn/broadcast/api-broadcast-fix-archive-statistics-post';
import { ApiBroadcastFixArchiveStatisticsPost$Params } from '../fn/broadcast/api-broadcast-fix-archive-statistics-post';
import { apiBroadcastImportContextPost } from '../fn/broadcast/api-broadcast-import-context-post';
import { ApiBroadcastImportContextPost$Params } from '../fn/broadcast/api-broadcast-import-context-post';
import { apiBroadcastListContextGet } from '../fn/broadcast/api-broadcast-list-context-get';
import { ApiBroadcastListContextGet$Params } from '../fn/broadcast/api-broadcast-list-context-get';
import { apiBroadcastListUtdbGet } from '../fn/broadcast/api-broadcast-list-utdb-get';
import { ApiBroadcastListUtdbGet$Params } from '../fn/broadcast/api-broadcast-list-utdb-get';
import { apiBroadcastOnStrymeGet } from '../fn/broadcast/api-broadcast-on-stryme-get';
import { ApiBroadcastOnStrymeGet$Params } from '../fn/broadcast/api-broadcast-on-stryme-get';
import { apiBroadcastPlayVttGet } from '../fn/broadcast/api-broadcast-play-vtt-get';
import { ApiBroadcastPlayVttGet$Params } from '../fn/broadcast/api-broadcast-play-vtt-get';
import { apiBroadcastReinitPost } from '../fn/broadcast/api-broadcast-reinit-post';
import { ApiBroadcastReinitPost$Params } from '../fn/broadcast/api-broadcast-reinit-post';
import { apiBroadcastRemovePost } from '../fn/broadcast/api-broadcast-remove-post';
import { ApiBroadcastRemovePost$Params } from '../fn/broadcast/api-broadcast-remove-post';
import { apiBroadcastStartRecordingPost } from '../fn/broadcast/api-broadcast-start-recording-post';
import { ApiBroadcastStartRecordingPost$Params } from '../fn/broadcast/api-broadcast-start-recording-post';
import { apiBroadcastStopRecordingPost } from '../fn/broadcast/api-broadcast-stop-recording-post';
import { ApiBroadcastStopRecordingPost$Params } from '../fn/broadcast/api-broadcast-stop-recording-post';
import { apiBroadcastUpdateDurationPost } from '../fn/broadcast/api-broadcast-update-duration-post';
import { ApiBroadcastUpdateDurationPost$Params } from '../fn/broadcast/api-broadcast-update-duration-post';
import { apiBroadcastUpdateLivestreamsourcePost } from '../fn/broadcast/api-broadcast-update-livestreamsource-post';
import { ApiBroadcastUpdateLivestreamsourcePost$Params } from '../fn/broadcast/api-broadcast-update-livestreamsource-post';
import { apiBroadcastUpdateRedsysNamePost } from '../fn/broadcast/api-broadcast-update-redsys-name-post';
import { ApiBroadcastUpdateRedsysNamePost$Params } from '../fn/broadcast/api-broadcast-update-redsys-name-post';
import { apiBroadcastUpdateStartPost } from '../fn/broadcast/api-broadcast-update-start-post';
import { ApiBroadcastUpdateStartPost$Params } from '../fn/broadcast/api-broadcast-update-start-post';
import { apiBroadcastUpdateTranscriptModifiedPost } from '../fn/broadcast/api-broadcast-update-transcript-modified-post';
import { ApiBroadcastUpdateTranscriptModifiedPost$Params } from '../fn/broadcast/api-broadcast-update-transcript-modified-post';
import { apiBroadcastVoxtralBindCorrectionCatalogPost } from '../fn/broadcast/api-broadcast-voxtral-bind-correction-catalog-post';
import { ApiBroadcastVoxtralBindCorrectionCatalogPost$Params } from '../fn/broadcast/api-broadcast-voxtral-bind-correction-catalog-post';
import { apiBroadcastVoxtralCorrectionContextPost } from '../fn/broadcast/api-broadcast-voxtral-correction-context-post';
import { ApiBroadcastVoxtralCorrectionContextPost$Params } from '../fn/broadcast/api-broadcast-voxtral-correction-context-post';
import { apiBroadcastVoxtralCorrectionContextsGet } from '../fn/broadcast/api-broadcast-voxtral-correction-contexts-get';
import { ApiBroadcastVoxtralCorrectionContextsGet$Params } from '../fn/broadcast/api-broadcast-voxtral-correction-contexts-get';
import { apiBroadcastVoxtralCorrectionContextsNameDelete } from '../fn/broadcast/api-broadcast-voxtral-correction-contexts-name-delete';
import { ApiBroadcastVoxtralCorrectionContextsNameDelete$Params } from '../fn/broadcast/api-broadcast-voxtral-correction-contexts-name-delete';
import { apiBroadcastVoxtralCorrectionContextsNameGet } from '../fn/broadcast/api-broadcast-voxtral-correction-contexts-name-get';
import { ApiBroadcastVoxtralCorrectionContextsNameGet$Params } from '../fn/broadcast/api-broadcast-voxtral-correction-contexts-name-get';
import { apiBroadcastVoxtralCorrectionContextsNamePut } from '../fn/broadcast/api-broadcast-voxtral-correction-contexts-name-put';
import { ApiBroadcastVoxtralCorrectionContextsNamePut$Params } from '../fn/broadcast/api-broadcast-voxtral-correction-contexts-name-put';
import { apiBroadcastVoxtralCorrectionsGet } from '../fn/broadcast/api-broadcast-voxtral-corrections-get';
import { ApiBroadcastVoxtralCorrectionsGet$Params } from '../fn/broadcast/api-broadcast-voxtral-corrections-get';
import { apiBroadcastVoxtralCorrectorActiveEc2IpGet } from '../fn/broadcast/api-broadcast-voxtral-corrector-active-ec-2-ip-get';
import { ApiBroadcastVoxtralCorrectorActiveEc2IpGet$Params } from '../fn/broadcast/api-broadcast-voxtral-corrector-active-ec-2-ip-get';
import { apiBroadcastVoxtralEnrichContextPost } from '../fn/broadcast/api-broadcast-voxtral-enrich-context-post';
import { ApiBroadcastVoxtralEnrichContextPost$Params } from '../fn/broadcast/api-broadcast-voxtral-enrich-context-post';
import { apiBroadcastVoxtralFabEnabledPost } from '../fn/broadcast/api-broadcast-voxtral-fab-enabled-post';
import { ApiBroadcastVoxtralFabEnabledPost$Params } from '../fn/broadcast/api-broadcast-voxtral-fab-enabled-post';
import { apiBroadcastVoxtralFabUrlPost } from '../fn/broadcast/api-broadcast-voxtral-fab-url-post';
import { ApiBroadcastVoxtralFabUrlPost$Params } from '../fn/broadcast/api-broadcast-voxtral-fab-url-post';
import { apiBroadcastVoxtralResetAllPost } from '../fn/broadcast/api-broadcast-voxtral-reset-all-post';
import { ApiBroadcastVoxtralResetAllPost$Params } from '../fn/broadcast/api-broadcast-voxtral-reset-all-post';
import { apiBroadcastVoxtralResetPost } from '../fn/broadcast/api-broadcast-voxtral-reset-post';
import { ApiBroadcastVoxtralResetPost$Params } from '../fn/broadcast/api-broadcast-voxtral-reset-post';
import { apiBroadcastVoxtralRestartAfterBroadcastPost } from '../fn/broadcast/api-broadcast-voxtral-restart-after-broadcast-post';
import { ApiBroadcastVoxtralRestartAfterBroadcastPost$Params } from '../fn/broadcast/api-broadcast-voxtral-restart-after-broadcast-post';
import { apiBroadcastVoxtralSegmentsExportGet } from '../fn/broadcast/api-broadcast-voxtral-segments-export-get';
import { ApiBroadcastVoxtralSegmentsExportGet$Params } from '../fn/broadcast/api-broadcast-voxtral-segments-export-get';
import { apiBroadcastVoxtralSegmentsGet } from '../fn/broadcast/api-broadcast-voxtral-segments-get';
import { ApiBroadcastVoxtralSegmentsGet$Params } from '../fn/broadcast/api-broadcast-voxtral-segments-get';
import { apiBroadcastVoxtralSetCorrectionModePost } from '../fn/broadcast/api-broadcast-voxtral-set-correction-mode-post';
import { ApiBroadcastVoxtralSetCorrectionModePost$Params } from '../fn/broadcast/api-broadcast-voxtral-set-correction-mode-post';
import { apiBroadcastVoxtralStartPost } from '../fn/broadcast/api-broadcast-voxtral-start-post';
import { ApiBroadcastVoxtralStartPost$Params } from '../fn/broadcast/api-broadcast-voxtral-start-post';
import { apiBroadcastVoxtralStopPost } from '../fn/broadcast/api-broadcast-voxtral-stop-post';
import { ApiBroadcastVoxtralStopPost$Params } from '../fn/broadcast/api-broadcast-voxtral-stop-post';
import { apiBroadcastVoxtralSupervisorStatusGet } from '../fn/broadcast/api-broadcast-voxtral-supervisor-status-get';
import { ApiBroadcastVoxtralSupervisorStatusGet$Params } from '../fn/broadcast/api-broadcast-voxtral-supervisor-status-get';
import { apiBroadcastVoxtralTerminatePost } from '../fn/broadcast/api-broadcast-voxtral-terminate-post';
import { ApiBroadcastVoxtralTerminatePost$Params } from '../fn/broadcast/api-broadcast-voxtral-terminate-post';
import { apiBroadcastVoxtralTestCorrectionPost } from '../fn/broadcast/api-broadcast-voxtral-test-correction-post';
import { ApiBroadcastVoxtralTestCorrectionPost$Params } from '../fn/broadcast/api-broadcast-voxtral-test-correction-post';

@Injectable({ providedIn: 'root' })
export class BroadcastService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiBroadcastRemovePost()` */
  static readonly ApiBroadcastRemovePostPath = '/api/Broadcast/remove';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastRemovePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastRemovePost$Response(params?: ApiBroadcastRemovePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastRemovePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastRemovePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastRemovePost(params?: ApiBroadcastRemovePost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastRemovePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastImportContextPost()` */
  static readonly ApiBroadcastImportContextPostPath = '/api/Broadcast/import-context';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastImportContextPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastImportContextPost$Response(params?: ApiBroadcastImportContextPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastImportContextPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastImportContextPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastImportContextPost(params?: ApiBroadcastImportContextPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastImportContextPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastListContextGet()` */
  static readonly ApiBroadcastListContextGetPath = '/api/Broadcast/list-context';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastListContextGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastListContextGet$Response(params?: ApiBroadcastListContextGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastListContextGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastListContextGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastListContextGet(params?: ApiBroadcastListContextGet$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastListContextGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastListUtdbGet()` */
  static readonly ApiBroadcastListUtdbGetPath = '/api/Broadcast/list-utdb';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastListUtdbGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastListUtdbGet$Response(params?: ApiBroadcastListUtdbGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastListUtdbGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastListUtdbGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastListUtdbGet(params?: ApiBroadcastListUtdbGet$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastListUtdbGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastReinitPost()` */
  static readonly ApiBroadcastReinitPostPath = '/api/Broadcast/reinit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastReinitPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastReinitPost$Response(params?: ApiBroadcastReinitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastReinitPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastReinitPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastReinitPost(params?: ApiBroadcastReinitPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastReinitPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastStopRecordingPost()` */
  static readonly ApiBroadcastStopRecordingPostPath = '/api/Broadcast/stop-recording';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastStopRecordingPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastStopRecordingPost$Response(params?: ApiBroadcastStopRecordingPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastStopRecordingPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastStopRecordingPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastStopRecordingPost(params?: ApiBroadcastStopRecordingPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastStopRecordingPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastStartRecordingPost()` */
  static readonly ApiBroadcastStartRecordingPostPath = '/api/Broadcast/start-recording';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastStartRecordingPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastStartRecordingPost$Response(params?: ApiBroadcastStartRecordingPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastStartRecordingPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastStartRecordingPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastStartRecordingPost(params?: ApiBroadcastStartRecordingPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastStartRecordingPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastEnableKiutPost()` */
  static readonly ApiBroadcastEnableKiutPostPath = '/api/Broadcast/enable-kiut';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastEnableKiutPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastEnableKiutPost$Response(params?: ApiBroadcastEnableKiutPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastEnableKiutPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastEnableKiutPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastEnableKiutPost(params?: ApiBroadcastEnableKiutPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastEnableKiutPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastUpdateStartPost()` */
  static readonly ApiBroadcastUpdateStartPostPath = '/api/Broadcast/update-start';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastUpdateStartPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastUpdateStartPost$Response(params?: ApiBroadcastUpdateStartPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastUpdateStartPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastUpdateStartPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastUpdateStartPost(params?: ApiBroadcastUpdateStartPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastUpdateStartPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastUpdateDurationPost()` */
  static readonly ApiBroadcastUpdateDurationPostPath = '/api/Broadcast/update-duration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastUpdateDurationPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastUpdateDurationPost$Response(params?: ApiBroadcastUpdateDurationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastUpdateDurationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastUpdateDurationPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastUpdateDurationPost(params?: ApiBroadcastUpdateDurationPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastUpdateDurationPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastUpdateRedsysNamePost()` */
  static readonly ApiBroadcastUpdateRedsysNamePostPath = '/api/Broadcast/update-redsys-name';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastUpdateRedsysNamePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastUpdateRedsysNamePost$Response(params?: ApiBroadcastUpdateRedsysNamePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastUpdateRedsysNamePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastUpdateRedsysNamePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastUpdateRedsysNamePost(params?: ApiBroadcastUpdateRedsysNamePost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastUpdateRedsysNamePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastUpdateLivestreamsourcePost()` */
  static readonly ApiBroadcastUpdateLivestreamsourcePostPath = '/api/Broadcast/update-livestreamsource';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastUpdateLivestreamsourcePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastUpdateLivestreamsourcePost$Response(params?: ApiBroadcastUpdateLivestreamsourcePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastUpdateLivestreamsourcePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastUpdateLivestreamsourcePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastUpdateLivestreamsourcePost(params?: ApiBroadcastUpdateLivestreamsourcePost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastUpdateLivestreamsourcePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastFetchRedsysStartDurationPost()` */
  static readonly ApiBroadcastFetchRedsysStartDurationPostPath = '/api/Broadcast/fetch-redsys-start-duration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastFetchRedsysStartDurationPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastFetchRedsysStartDurationPost$Response(params?: ApiBroadcastFetchRedsysStartDurationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastFetchRedsysStartDurationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastFetchRedsysStartDurationPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastFetchRedsysStartDurationPost(params?: ApiBroadcastFetchRedsysStartDurationPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastFetchRedsysStartDurationPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastOnStrymeGet()` */
  static readonly ApiBroadcastOnStrymeGetPath = '/api/Broadcast/on-stryme';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastOnStrymeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastOnStrymeGet$Response(params?: ApiBroadcastOnStrymeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastOnStrymeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastOnStrymeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastOnStrymeGet(params?: ApiBroadcastOnStrymeGet$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastOnStrymeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastPlayVttGet()` */
  static readonly ApiBroadcastPlayVttGetPath = '/api/Broadcast/play-vtt';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastPlayVttGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastPlayVttGet$Response(params?: ApiBroadcastPlayVttGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastPlayVttGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastPlayVttGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastPlayVttGet(params?: ApiBroadcastPlayVttGet$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastPlayVttGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastBroadcastStatisticsGet()` */
  static readonly ApiBroadcastBroadcastStatisticsGetPath = '/api/Broadcast/broadcast-statistics';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastBroadcastStatisticsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastBroadcastStatisticsGet$Response(params?: ApiBroadcastBroadcastStatisticsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastBroadcastStatisticsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastBroadcastStatisticsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastBroadcastStatisticsGet(params?: ApiBroadcastBroadcastStatisticsGet$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastBroadcastStatisticsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastCheckUtdbGet()` */
  static readonly ApiBroadcastCheckUtdbGetPath = '/api/Broadcast/check-utdb';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastCheckUtdbGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastCheckUtdbGet$Response(params?: ApiBroadcastCheckUtdbGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastCheckUtdbGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastCheckUtdbGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastCheckUtdbGet(params?: ApiBroadcastCheckUtdbGet$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastCheckUtdbGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastUpdateTranscriptModifiedPost()` */
  static readonly ApiBroadcastUpdateTranscriptModifiedPostPath = '/api/Broadcast/update-transcript-modified';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastUpdateTranscriptModifiedPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastUpdateTranscriptModifiedPost$Response(params?: ApiBroadcastUpdateTranscriptModifiedPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastUpdateTranscriptModifiedPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastUpdateTranscriptModifiedPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastUpdateTranscriptModifiedPost(params?: ApiBroadcastUpdateTranscriptModifiedPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastUpdateTranscriptModifiedPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastDevTestGet()` */
  static readonly ApiBroadcastDevTestGetPath = '/api/Broadcast/dev-test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastDevTestGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastDevTestGet$Response(params?: ApiBroadcastDevTestGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastDevTestGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastDevTestGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastDevTestGet(params?: ApiBroadcastDevTestGet$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastDevTestGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastFixArchiveStatisticsPost()` */
  static readonly ApiBroadcastFixArchiveStatisticsPostPath = '/api/Broadcast/fix-archive-statistics';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastFixArchiveStatisticsPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastFixArchiveStatisticsPost$Response(params?: ApiBroadcastFixArchiveStatisticsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastFixArchiveStatisticsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastFixArchiveStatisticsPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastFixArchiveStatisticsPost(params?: ApiBroadcastFixArchiveStatisticsPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastFixArchiveStatisticsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastFixArchiveDurationPost()` */
  static readonly ApiBroadcastFixArchiveDurationPostPath = '/api/Broadcast/fix-archive-duration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastFixArchiveDurationPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastFixArchiveDurationPost$Response(params?: ApiBroadcastFixArchiveDurationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastFixArchiveDurationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastFixArchiveDurationPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastFixArchiveDurationPost(params?: ApiBroadcastFixArchiveDurationPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastFixArchiveDurationPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralStartPost()` */
  static readonly ApiBroadcastVoxtralStartPostPath = '/api/Broadcast/voxtral-start';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralStartPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralStartPost$Response(params?: ApiBroadcastVoxtralStartPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralStartPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralStartPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralStartPost(params?: ApiBroadcastVoxtralStartPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralStartPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralFabEnabledPost()` */
  static readonly ApiBroadcastVoxtralFabEnabledPostPath = '/api/Broadcast/voxtral-fab-enabled';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralFabEnabledPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralFabEnabledPost$Response(params?: ApiBroadcastVoxtralFabEnabledPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralFabEnabledPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralFabEnabledPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralFabEnabledPost(params?: ApiBroadcastVoxtralFabEnabledPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralFabEnabledPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralFabUrlPost()` */
  static readonly ApiBroadcastVoxtralFabUrlPostPath = '/api/Broadcast/voxtral-fab-url';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralFabUrlPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralFabUrlPost$Response(params?: ApiBroadcastVoxtralFabUrlPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralFabUrlPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralFabUrlPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralFabUrlPost(params?: ApiBroadcastVoxtralFabUrlPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralFabUrlPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralRestartAfterBroadcastPost()` */
  static readonly ApiBroadcastVoxtralRestartAfterBroadcastPostPath = '/api/Broadcast/voxtral-restart-after-broadcast';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralRestartAfterBroadcastPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralRestartAfterBroadcastPost$Response(params?: ApiBroadcastVoxtralRestartAfterBroadcastPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralRestartAfterBroadcastPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralRestartAfterBroadcastPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralRestartAfterBroadcastPost(params?: ApiBroadcastVoxtralRestartAfterBroadcastPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralRestartAfterBroadcastPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralCorrectionContextPost()` */
  static readonly ApiBroadcastVoxtralCorrectionContextPostPath = '/api/Broadcast/voxtral-correction-context';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralCorrectionContextPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralCorrectionContextPost$Response(params?: ApiBroadcastVoxtralCorrectionContextPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralCorrectionContextPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralCorrectionContextPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralCorrectionContextPost(params?: ApiBroadcastVoxtralCorrectionContextPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralCorrectionContextPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralBindCorrectionCatalogPost()` */
  static readonly ApiBroadcastVoxtralBindCorrectionCatalogPostPath = '/api/Broadcast/voxtral-bind-correction-catalog';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralBindCorrectionCatalogPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralBindCorrectionCatalogPost$Response(params?: ApiBroadcastVoxtralBindCorrectionCatalogPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralBindCorrectionCatalogPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralBindCorrectionCatalogPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralBindCorrectionCatalogPost(params?: ApiBroadcastVoxtralBindCorrectionCatalogPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralBindCorrectionCatalogPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralSetCorrectionModePost()` */
  static readonly ApiBroadcastVoxtralSetCorrectionModePostPath = '/api/Broadcast/voxtral-set-correction-mode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralSetCorrectionModePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralSetCorrectionModePost$Response(params?: ApiBroadcastVoxtralSetCorrectionModePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralSetCorrectionModePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralSetCorrectionModePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralSetCorrectionModePost(params?: ApiBroadcastVoxtralSetCorrectionModePost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralSetCorrectionModePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralEnrichContextPost()` */
  static readonly ApiBroadcastVoxtralEnrichContextPostPath = '/api/Broadcast/voxtral-enrich-context';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralEnrichContextPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralEnrichContextPost$Response(params?: ApiBroadcastVoxtralEnrichContextPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralEnrichContextPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralEnrichContextPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralEnrichContextPost(params?: ApiBroadcastVoxtralEnrichContextPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralEnrichContextPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralStopPost()` */
  static readonly ApiBroadcastVoxtralStopPostPath = '/api/Broadcast/voxtral-stop';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralStopPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralStopPost$Response(params?: ApiBroadcastVoxtralStopPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralStopPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralStopPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralStopPost(params?: ApiBroadcastVoxtralStopPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralStopPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralTerminatePost()` */
  static readonly ApiBroadcastVoxtralTerminatePostPath = '/api/Broadcast/voxtral-terminate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralTerminatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralTerminatePost$Response(params?: ApiBroadcastVoxtralTerminatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralTerminatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralTerminatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralTerminatePost(params?: ApiBroadcastVoxtralTerminatePost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralTerminatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralResetPost()` */
  static readonly ApiBroadcastVoxtralResetPostPath = '/api/Broadcast/voxtral-reset';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralResetPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralResetPost$Response(params?: ApiBroadcastVoxtralResetPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralResetPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralResetPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralResetPost(params?: ApiBroadcastVoxtralResetPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralResetPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralResetAllPost()` */
  static readonly ApiBroadcastVoxtralResetAllPostPath = '/api/Broadcast/voxtral-reset-all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralResetAllPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralResetAllPost$Response(params?: ApiBroadcastVoxtralResetAllPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralResetAllPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralResetAllPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralResetAllPost(params?: ApiBroadcastVoxtralResetAllPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralResetAllPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralCorrectionsGet()` */
  static readonly ApiBroadcastVoxtralCorrectionsGetPath = '/api/Broadcast/voxtral-corrections';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralCorrectionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastVoxtralCorrectionsGet$Response(params?: ApiBroadcastVoxtralCorrectionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralCorrectionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralCorrectionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastVoxtralCorrectionsGet(params?: ApiBroadcastVoxtralCorrectionsGet$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralCorrectionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralSegmentsGet()` */
  static readonly ApiBroadcastVoxtralSegmentsGetPath = '/api/Broadcast/voxtral-segments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralSegmentsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastVoxtralSegmentsGet$Response(params?: ApiBroadcastVoxtralSegmentsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralSegmentsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralSegmentsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastVoxtralSegmentsGet(params?: ApiBroadcastVoxtralSegmentsGet$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralSegmentsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralSupervisorStatusGet()` */
  static readonly ApiBroadcastVoxtralSupervisorStatusGetPath = '/api/Broadcast/voxtral-supervisor-status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralSupervisorStatusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastVoxtralSupervisorStatusGet$Response(params?: ApiBroadcastVoxtralSupervisorStatusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralSupervisorStatusGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralSupervisorStatusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastVoxtralSupervisorStatusGet(params?: ApiBroadcastVoxtralSupervisorStatusGet$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralSupervisorStatusGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralTestCorrectionPost()` */
  static readonly ApiBroadcastVoxtralTestCorrectionPostPath = '/api/Broadcast/voxtral-test-correction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralTestCorrectionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralTestCorrectionPost$Response(params?: ApiBroadcastVoxtralTestCorrectionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralTestCorrectionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralTestCorrectionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralTestCorrectionPost(params?: ApiBroadcastVoxtralTestCorrectionPost$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralTestCorrectionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralSegmentsExportGet()` */
  static readonly ApiBroadcastVoxtralSegmentsExportGetPath = '/api/Broadcast/voxtral-segments-export';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralSegmentsExportGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastVoxtralSegmentsExportGet$Response(params?: ApiBroadcastVoxtralSegmentsExportGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralSegmentsExportGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralSegmentsExportGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastVoxtralSegmentsExportGet(params?: ApiBroadcastVoxtralSegmentsExportGet$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralSegmentsExportGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralCorrectionContextsGet()` */
  static readonly ApiBroadcastVoxtralCorrectionContextsGetPath = '/api/Broadcast/voxtral/correction-contexts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralCorrectionContextsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastVoxtralCorrectionContextsGet$Response(params?: ApiBroadcastVoxtralCorrectionContextsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralCorrectionContextsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralCorrectionContextsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastVoxtralCorrectionContextsGet(params?: ApiBroadcastVoxtralCorrectionContextsGet$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralCorrectionContextsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralCorrectionContextsNameGet()` */
  static readonly ApiBroadcastVoxtralCorrectionContextsNameGetPath = '/api/Broadcast/voxtral/correction-contexts/{name}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralCorrectionContextsNameGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastVoxtralCorrectionContextsNameGet$Response(params: ApiBroadcastVoxtralCorrectionContextsNameGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralCorrectionContextsNameGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralCorrectionContextsNameGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastVoxtralCorrectionContextsNameGet(params: ApiBroadcastVoxtralCorrectionContextsNameGet$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralCorrectionContextsNameGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralCorrectionContextsNamePut()` */
  static readonly ApiBroadcastVoxtralCorrectionContextsNamePutPath = '/api/Broadcast/voxtral/correction-contexts/{name}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralCorrectionContextsNamePut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralCorrectionContextsNamePut$Response(params: ApiBroadcastVoxtralCorrectionContextsNamePut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralCorrectionContextsNamePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralCorrectionContextsNamePut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralCorrectionContextsNamePut(params: ApiBroadcastVoxtralCorrectionContextsNamePut$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralCorrectionContextsNamePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralCorrectionContextsNameDelete()` */
  static readonly ApiBroadcastVoxtralCorrectionContextsNameDeletePath = '/api/Broadcast/voxtral/correction-contexts/{name}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralCorrectionContextsNameDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralCorrectionContextsNameDelete$Response(params: ApiBroadcastVoxtralCorrectionContextsNameDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralCorrectionContextsNameDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralCorrectionContextsNameDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBroadcastVoxtralCorrectionContextsNameDelete(params: ApiBroadcastVoxtralCorrectionContextsNameDelete$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralCorrectionContextsNameDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiBroadcastVoxtralCorrectorActiveEc2IpGet()` */
  static readonly ApiBroadcastVoxtralCorrectorActiveEc2IpGetPath = '/api/Broadcast/voxtral/corrector-active/{ec2Ip}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBroadcastVoxtralCorrectorActiveEc2IpGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastVoxtralCorrectorActiveEc2IpGet$Response(params: ApiBroadcastVoxtralCorrectorActiveEc2IpGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiBroadcastVoxtralCorrectorActiveEc2IpGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBroadcastVoxtralCorrectorActiveEc2IpGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBroadcastVoxtralCorrectorActiveEc2IpGet(params: ApiBroadcastVoxtralCorrectorActiveEc2IpGet$Params, context?: HttpContext): Observable<void> {
    return this.apiBroadcastVoxtralCorrectorActiveEc2IpGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
